import React from 'react';
import { Carousel } from 'react-bootstrap';
import './Slider.css';
import pik1 from './ayo-ogunseinde-6W4F62sN_yI-unsplash.jpg'
// import pik3 from './jurica-koletic-7YVZYZeITc8-unsplash (1).jpg'
import pik4 from './joseph-gonzalez-iFgRcqHznqg-unsplash.jpg'
import pik5 from './lucas-lenzi-b5zPZ8_7vhw-unsplash.jpg'
import pik6 from './nicolas-horn-MTZTGvDsHFY-unsplash.jpg'


const Slider = () => {
  return (
    <div className='px-3 text-center'>
      <h2 style={{ fontWeight: 'bold' }} className='text-primary text-center my-5 py-3'>THIS IS OUR SUCCESSFUL STUDENT</h2>
      <div className='' style={{ height: '500px' }}>
        <button style={{ fontWeight: 'bold' }} className='btn btn-primary fs-5'>LETS GO NOW</button>

        <Carousel>
          <Carousel.Item>
            <div className="slider-img">
              <img
                className="d-block  mx-auto"
                src={pik1}
                alt="First slide"
              />
            </div>

            <div className='text-center line text-justify'>
              <h5>SULTANA KHONDOKAR</h5>
              <p>I am reading online to this sir in Corona,
                now I am working in a good place, so I have benefited this site.
                and your can join our website because it is so good</p>
            </div>



          </Carousel.Item>

          <Carousel.Item>
            <div className="slider-img">
              <img
                className="d-block  mx-auto"
                src={pik4}
                alt="Third slide"
              />
            </div>
            <div className='text-center line'>
              <h5>AKBAR ALI</h5>
              <p>I am reading online to this sir in Corona,
                now I am working in a good place, so I have benefited this site.
                and your can join our website because it is so good</p>
            </div>

          </Carousel.Item>
          <Carousel.Item>
            <div className="slider-img">
              <img
                className="d-block  mx-auto"
                src={pik6}
                alt="fourth slide"
              />
            </div>
            <div className='text-center line'>
              <h5>MASUM BELLAH</h5>
              <p>I am reading online to this sir in Corona,
                now I am working in a good place, so I have benefited this site.
                and your can join our website because it is so good</p>
            </div>

          </Carousel.Item>
          <Carousel.Item>
            <div className="slider-img">
              <img
                className="d-block  mx-auto"
                src={pik5}
                alt="fivth slide"
              />
            </div>
            <div className='text-center line'>
              <h5>MUMIN KHAN</h5>
              <p>I am reading online to this sir in Corona,
                now I am working in a good place, so I have benefited this site.
                and your can join our website because it is so good</p>
            </div>

          </Carousel.Item>
        </Carousel>
      </div>
    </div >
  );
};

export default Slider;